<!--
 * @Author: Merlin
 * @Date: 2023-12-08 16:50:26
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-12 17:26:38
 * @Description: 
-->
<template>
    <TheNav></TheNav>
    <div class="p-8" >
        <h2>
            整数: {{ intValue }}
            &emsp;|&emsp;
            小数: {{ floatValue }}
            &emsp;|&emsp;
            <ButtonGrayButton @click="() => isDisabled = !isDisabled">
                当前是否禁用 {{ isDisabled }}（点击切换）
            </ButtonGrayButton>
        </h2>
        <br/>
        <br/>
        <h3>小输入框</h3>
        <section class="grid grid-cols-5 gap-4">
            <InputBoxAmount :disabled="isDisabled"  v-model="intValue" 
                maxlength="3"
            />
            <InputBoxAmount :disabled="isDisabled"  v-model="intValue" 
                suffix="w"
            />
            <InputBoxAmount :disabled="isDisabled"  v-model="intValue" 
                label="有后缀" suffix="%"
            />
            <InputBoxAmount :disabled="isDisabled"  v-model="intValue" 
                label="有按钮" ref="inputWithBtn01"
            />
            <ButtonGrayButton @click="() => inputWithBtn01.isBlue = false">
                ← 去除左侧的蓝色效果
            </ButtonGrayButton>
        </section>
        <br/>
        <br/>
        <h3>基本用法</h3>
        <section class="grid grid-cols-5 gap-4">
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="输入整数(3位数)"
                maxlength="3"
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="floatValue" 
                label="输入小数"
                inputmode="decimal"
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="有图标" icon
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="前后缀"
                prefix="$"
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="有后缀"
                suffix="x"
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="有副标题"
                label02="有副标题"
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="有右侧按钮"
                :showButton="true"
            />
        </section>
        <br/>
        <br/>
        <h3>限定数字最小值/最大值</h3>
        <section class="grid grid-cols-5 gap-4">
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="允许为空值" :showButton="true"
                placeholder="0"
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="最小数为9" suffix="x"
                :min="9"
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="floatValue" inputmode="decimal"
                label="最大999.99" suffix="y"
                :max="999.99"
            />
        </section>
        <br/>
        <br/>
        <h3>数字过大/过小会弹出提示</h3>
        <section class="grid grid-cols-5 gap-4">
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="小于 9 提示"
                suffix="y"
                :min="9"
                :max="999"
                :tip="oTip01"
                key="tip-min"
            />
            <InputBoxAmount :disabled="isDisabled" mode="multiple" v-model="intValue" 
                label="小于9，大于999 都提示"
                suffix="x"
                :min="9"
                :max="999"
                :tip="oTip02"
                key="tip-both"
            />
        </section>
        <br/>
    </div>
</template>

<script setup>
import TheNav from './nav.vue';
import { useI18n } from "vue-i18n";

const {t: $t} = useI18n();
const intValue = ref(666);
const floatValue = ref(123.456);
const inputWithBtn01 = ref(null);
const isDisabled = ref(false);

const oTip01 = ref({
    min: $t(`minMax.min_coefficient`),
});
const oTip02 = ref({
    min: $t(`minMax.min_coefficient`),
    max: $t(`minMax.max_coefficient`),
});

</script>

<style>

</style>
